import React from 'react'
import { connect } from 'react-redux'
import HomePage from '../components/home/HomePage'
import { updateSeatCount } from '../actions/seatCount'
import { updateCurrency } from '../actions/currency'

function HomeContainer({
  seatCount, discountRates, currency, updateCurrency, updateSeatCount,
}) {
  return (
    <HomePage
      seatCount={seatCount}
      setSeatCount={updateSeatCount}
      currency={currency}
      setCurrency={updateCurrency}
      discountRates={discountRates}
    />
  )
}

export default connect(
  (state) => ({
    seatCount: state.seatCount,
    currency: state.currency,
    discountRates: state.discountRates,
  }),
  { updateSeatCount, updateCurrency },
)(HomeContainer)
